module.exports = __webpack_public_path__ + "33ce56273543deb46e2cdb7663a89421.svg";